import { LegacyProviderRegistryApi } from "@asd/customer-portal-api";
import { AxiosResponse } from "axios";

import AxiosConfigurations, { AxiosConfiguration } from "./AxiosConfiguration";

import { axiosInstance } from ".";

export class LegacyRegistryService {
  static instance: LegacyRegistryService;
  private legacyRegistryApi;
  private axiosConfiguration: AxiosConfiguration | undefined;

  constructor() {
    if (LegacyRegistryService.instance) {
      return LegacyRegistryService.instance;
    }

    this.legacyRegistryApi = new LegacyProviderRegistryApi(undefined, undefined, axiosInstance);
    const config = AxiosConfigurations.createAxiosConfiguration("legacyRegistryService", this.legacyRegistryApi);
    if (!config) {
      throw new Error("Failed to create AxiosConfiguration for legacyRegistryService");
    }
    this.axiosConfiguration = config;

    LegacyRegistryService.instance = this;
  }

  public getPendingRequestCount() {
    return this.axiosConfiguration?.getPendingRequestCount();
  }

  public async getProviderRegistry(search?: string, page?: number, size?: number, sort?: Array<string>, options: object = {}) {
    if (!this.legacyRegistryApi) {
      throw new Error("legacyRegistryApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.legacyRegistryApi.getProviderRegistry(
        search?.length ? search : undefined,
        page,
        size,
        sort?.length ? sort : undefined,
        options,
      );
      return response;
    } catch {
      // do nothing
    }
  }

  public async exportProviderRegistryCsv(search?: string, sort?: Array<string>, options: object = {}) {
    if (!this.legacyRegistryApi) {
      throw new Error("registryApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.legacyRegistryApi.exportProviderRegistryCsv(
        search?.length ? search : undefined,
        sort?.length ? sort : undefined,
        options,
      );

      return response.data;
    } catch {
      // do nothing
    }
  }
}

export default new LegacyRegistryService();
